// extracted by mini-css-extract-plugin
module.exports = {"field":"ValueGroup_field__Sr8NV","des":"ValueGroup_des__K_XWY","value":"ValueGroup_value__AjezQ"};